import { useState } from 'react';
import { sanitizeQuillHtml } from 'src/components/atoms/ReadOnlyRichText/sanitizeQuillHtml';
import {
  CloseButtonContainer,
  Container,
  Description,
  DescriptionHeader,
  HelpButton,
  Name,
  Pop,
  SelectableContent,
  Spacing,
  Tick,
} from './SubmissionType.styles';

interface Props {
  name: string;
  active: boolean;
  description?: string;
  onClick: () => void;
  index?: number;
}

export const SubmissionType = ({
  name,
  active,
  description,
  onClick,
  index,
}: Props) => {
  const [showDescription, setShowDescription] = useState(false);

  return (
    <Container active={active}>
      <Spacing>
        <SelectableContent data-testid="submission-type" onClick={onClick}>
          <Tick
            data-testid={`submission-type-tick-${index}`}
            src={active ? '/assets/tick-full.png' : '/assets/tick-empty.png'}
          />
          <p>{name}</p>
        </SelectableContent>
        <HelpButton
          data-testid={`submission-type-help-${index}`}
          onClick={() => setShowDescription(!showDescription)}
          src="/assets/questionMarkGrey.png"
        />
      </Spacing>
      {description && (
        <Pop
          open={showDescription}
          onClose={() => setShowDescription(!showDescription)}
        >
          <Description>
            <DescriptionHeader>
              <Name>
                <h3>{name}</h3>
              </Name>
              <CloseButtonContainer>
                <img
                  alt=""
                  data-testid="submission-type-modal-close"
                  src={'/assets/close-icon-green.png'}
                  onClick={() => setShowDescription(!showDescription)}
                />
              </CloseButtonContainer>
            </DescriptionHeader>
            <div
              dangerouslySetInnerHTML={{
                __html: sanitizeQuillHtml(description, {
                  normalizeSpaces: true,
                }),
              }}
            />
          </Description>
        </Pop>
      )}
    </Container>
  );
};
